import { render } from "./ShowsView.vue?vue&type=template&id=1dec29be&scoped=true&ts=true"
import script from "./ShowsView.vue?vue&type=script&lang=ts"
export * from "./ShowsView.vue?vue&type=script&lang=ts"

import "./ShowsView.vue?vue&type=style&index=0&id=1dec29be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dec29be"]])

export default __exports__